export default number => {
  let formattedNumber = Number(number).toFixed(2);
  if (number < 1 && number > 0) {
    formattedNumber = Number(number).toFixed(4);
    return formattedNumber;
  }
  return addCommaToNumber(formattedNumber);
};

const addCommaToNumber = input =>
  input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
